import MenuItemCardContainer from './MenuItemCardContainer';

export default MenuItemCardContainer;
